import { v4 as uuidv4 } from 'uuid';
import { images } from '../../constants';

export const frontendSkillsData = [
  { id: uuidv4(), name: 'JavaScript', image: images.javascript },
  { id: uuidv4(), name: 'React JS', image: images.react },
  { id: uuidv4(), name: 'Redux', image: images.redux },
  { id: uuidv4(), name: 'HTML', image: images.html },
  { id: uuidv4(), name: 'CSS', image: images.css },
  { id: uuidv4(), name: 'SCSS', image: images.sass },
];

export const backendSkillsData = [
  { id: uuidv4(), name: 'Ruby', image: images.ruby },
  { id: uuidv4(), name: 'Ruby on Rails', image: images.rails },
  { id: uuidv4(), name: 'PostgreSQL', image: images.postgres },
  { id: uuidv4(), name: 'Postman', image: images.postman },
];

export const toolsSkillsData = [
  { id: uuidv4(), name: 'Git', image: images.git },
  { id: uuidv4(), name: 'Github', image: images.github },
  { id: uuidv4(), name: 'NPM', image: images.npm },
  { id: uuidv4(), name: 'WebpacK', image: images.webpack },
  { id: uuidv4(), name: 'VS CODE', image: images.vscode },
  { id: uuidv4(), name: 'JEST', image: images.jest },
  { id: uuidv4(), name: 'RSpec', image: images.rspec },
  { id: uuidv4(), name: 'Chrome Dev Tools', image: images.chromedev },
  { id: uuidv4(), name: 'Postman', image: images.postman },
];

export const communicationSkillsData = [
  { id: uuidv4(), name: 'Slack', image: images.slack },
  { id: uuidv4(), name: 'Skype', image: images.skype },
  { id: uuidv4(), name: 'Google Meet', image: images.googlemeet },
  { id: uuidv4(), name: 'Zoom', image: images.zoom },
];

export const softSkillsData = [
  { id: uuidv4(), name: 'Effective Communication' },
  { id: uuidv4(), name: 'Collaborator' },
  { id: uuidv4(), name: 'Remote Pair Programming' },
  { id: uuidv4(), name: 'Critical Thinking' },
  { id: uuidv4(), name: 'Time Management' },
  { id: uuidv4(), name: 'Problem-Solving' },
  { id: uuidv4(), name: 'Decision-Making' },
  { id: uuidv4(), name: 'Mentor' },
  { id: uuidv4(), name: 'Leadership' },
];
